import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, nextTick, computed, ref, watch } from 'vue'
import Category from '@/components/bussiness/Category/Category.vue'
import Carousel from '@/components/common/Carousel.vue'
import PlatChannel from '@/views/index/Pure/components/PlatChannel.vue'
import FragChannel from '@/views/index/Pure/components/FragChannel.vue'
import MemberBanner from '@/components/bussiness/MemberBanner.vue'
import MemberFloating from '@/components/bussiness/MemberFloating.vue'
import LiveCardBox from '@/components/LiveCardBox/index.vue'
import NationalCard from './components/NationalCard.vue'
import NationalLogin from './components/NationalLogin.vue'
import CancelOrderInfo from './components/CancelOrderInfo.vue'
import { useStore } from 'vuex'
import { isJA, useSite2Code, useSite2Station } from '@/store'
import { TaEvent, taTrack, usePageDuration } from '@/util/buryingPoint'

// 是否登录

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isLogin = computed(() => store.getters.isLogin)
const liveCardBoxRef = ref<any>()

// 存在直播
const isExistLive = computed(() => {
  return liveCardBoxRef.value?.getIsExistLive() ?? false
})

const store = useStore()
const shops = computed(() => store.getters.userShops)
const customerId = computed(() => store.getters?.user?.customerId)

//
const showGuide = () => {
  nextTick(() => {
    if (store.getters.isLogin) {
      store.dispatch('guide/openGuide', { guideKey: 'guide-pure-all' })
    }
    if (store.state.route.token && !shops.value.length) {
      if (store.state.guide.isUpdateData) {
        store.dispatch('guide/showGuide', { guideKey: 'guide-createShop-all', localTrigger: true })
      } else {
        store.dispatch('guide/getGuide', { customerId: customerId }).then(() => {
          store.dispatch('guide/showGuide', { guideKey: 'guide-createShop-all', localTrigger: true })
        })
      }
    }
  })
}

onMounted(() => {
  taTrack({
    event: TaEvent.PAGE_VIEW,
    value: {
      position: 'home_page'
    }
  })
  // 新手引导唤起
  store.commit('bussiness/platformType', 'AM')
  showGuide()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isJA)())
      ? (_openBlock(), _createBlock(LiveCardBox, {
          key: 0,
          ref: (_value, _refs) => {
            _refs['liveCardBoxRef'] = _value
            liveCardBoxRef.value = _value
          }
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(Category),
    (_unref(isJA)() && !_unref(isLogin))
      ? (_openBlock(), _createBlock(NationalLogin, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(MemberBanner),
    (!_unref(isExistLive))
      ? (_openBlock(), _createBlock(MemberFloating, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(Carousel, { type: "1" }),
    (_unref(isJA)())
      ? (_openBlock(), _createBlock(NationalCard, { key: 3 }))
      : _createCommentVNode("", true),
    _createVNode(PlatChannel),
    _createVNode(FragChannel),
    (_unref(isJA)())
      ? (_openBlock(), _createBlock(CancelOrderInfo, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})